// Client-side WhatsApp helpers — uses wa.me deep links so no WhatsApp Cloud
// / Business API is needed. The user's phone / desktop opens WhatsApp with a
// prefilled message; they tap Send.

// Normalise an Indian mobile to E.164-ish (no +, wa.me strips leading zeros).
export const cleanPhone = (num) => {
  const digits = String(num || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.length === 10) return `91${digits}`; // assume India if 10-digit
  return digits.replace(/^0+/, "");
};

// Fill placeholders like {tenant_name} from a data object; missing → empty string.
export const renderTemplate = (tpl, data) =>
  String(tpl || "").replace(/\{(\w+)\}/g, (_, k) => (data[k] == null ? "" : String(data[k])));

// Open WhatsApp with a prefilled message to `phone`.
export const openWhatsApp = (phone, text) => {
  const p = cleanPhone(phone);
  if (!p) throw new Error("no-phone");
  const url = `https://wa.me/${p}?text=${encodeURIComponent(text)}`;
  window.open(url, "_blank", "noopener,noreferrer");
  return url;
};

// Build the standard portal link a tenant would tap.
export const portalLink = () => `${window.location.origin}/portal/login`;
